import { combineReducers } from "redux";

import {
  SCHEDULE_GET_LOADING,
  SCHEDULE_GET_ERROR,
  SCHEDULE_GET_SUCCESS,
  SCHEDULE_VIEW_ERROR,
  SCHEDULE_VIEW_LOADING,
  SCHEDULE_VIEW_SUCCESS,
  SCHEDULE_ADD_ERROR,
  SCHEDULE_ADD_LOADING,
  SCHEDULE_ADD_SUCCESS,
  SCHEDULE_DELETE_ERROR,
  SCHEDULE_DELETE_LOADING,
  SCHEDULE_DELETE_SUCCESS,
  SCHEDULE_GET_BOOKING,
  SCHEDULE_APPROVE_OR_CANCEL_CONTAINER,
  SCHEDULE_GET_CONTAINER_FROM_BOOKING,
  SCHEDULE_APPROVE_CANCEL_BOOKING,
  SCHEDULE_ADD_INVALID,
  SCHEDULE_GET_HISTORY,
  SCHEDULE_GET_VOYAGE,
  SCHEDULE_UBAH_COMMITTED,
} from "../actions/constant";

import {
  HANDLE_CHANGE_TO_PLAN_LOADING,
  HANDLE_CHANGE_TO_PLAN_SUCCESS,
  HANDLE_CHANGE_TO_PLAN_ERROR,
  HANDLE_SHIP_ARRIVED_LOADING,
  HANDLE_SHIP_ARRIVED_SUCCESS,
  HANDLE_SHIP_ARRIVED_ERROR,
  GET_KSOP_PORT_LOADING,
  GET_KSOP_PORT_SUCCESS,
  GET_KSOP_PORT_ERROR,
  GET_TRAYEK_LIST_LOADING,
  GET_TRAYEK_LIST_SUCCESS,
  GET_TRAYEK_LIST_ERROR,
  GET_JADWAL_LIST_SUCCESS,
  GET_JADWAL_LIST_ERROR,
  GET_JADWAL_LIST_LOADING,
  GET_QUOTA_LIST_LOADING,
  GET_QUOTA_LIST_SUCCESS,
  GET_QUOTA_LIST_ERROR,
  UPDATE_QUOTA_LOADING,
  UPDATE_QUOTA_SUCCESS,
  UPDATE_QUOTA_ERROR,
} from "../actions/scheduleAction";

const scheduleGetBooking = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_GET_BOOKING:
      return action.schedule;
    default:
      return state;
  }
};

const scheduleApproveCancelContainer = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_APPROVE_OR_CANCEL_CONTAINER:
      return action.scheduleGetSuccess;
    default:
      return state;
  }
};

const scheduleGetContainerFromBooking = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_GET_CONTAINER_FROM_BOOKING:
      return action.schedule;
    default:
      return state;
  }
};

const scheduleApproveCancelBooking = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_APPROVE_CANCEL_BOOKING:
      return action.scheduleGetSuccess;
    default:
      return state;
  }
};

const scheduleGetInvalid = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_ADD_INVALID:
      return action.scheduleGetInvalid;
    default:
      return state;
  }
};

const invalid = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_ADD_INVALID:
      return action.invalid;
    default:
      return state;
  }
};

const scheduleGetHistory = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_GET_HISTORY:
      return action.scheduleGetHist;
    default:
      return state;
  }
};

const history = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_GET_HISTORY:
      return action.history;
    default:
      return state;
  }
};

const scheduleGetVoyage = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_GET_VOYAGE:
      return action.voyage;
    default:
      return state;
  }
};

const scheduleSuccessVoyage = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_GET_VOYAGE:
      return action.scheduleGetVoy;
    default:
      return state;
  }
};

const scheduleUbahCommitted = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_UBAH_COMMITTED:
      return action.scheduleGetCommitted;
    default:
      return state;
  }
};

const scheduleGetError = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_GET_ERROR:
      return action.scheduleGetError;
    default:
      return state;
  }
};

const scheduleGetLoading = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_GET_LOADING:
      return action.scheduleGetLoading;
    default:
      return state;
  }
};

const scheduleGetSuccess = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_GET_SUCCESS:
      return action.scheduleGetSuccess;
    default:
      return state;
  }
};

const schedules = (state = null, action) => {
  switch (action.type) {
    case SCHEDULE_GET_SUCCESS:
      return action.schedules;
    default:
      return state;
  }
};

const scheduleViewLoading = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_VIEW_LOADING:
      return action.scheduleViewLoading;
    default:
      return state;
  }
};

const scheduleViewError = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_VIEW_ERROR:
      return action.scheduleViewError;
    default:
      return state;
  }
};

const scheduleViewSuccess = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_VIEW_SUCCESS:
      return action.scheduleViewSuccess;
    default:
      return state;
  }
};

const schedule = (state = [], action) => {
  switch (action.type) {
    case SCHEDULE_VIEW_SUCCESS:
      return action.schedule;
    default:
      return state;
  }
};

const scheduleAddError = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_ADD_ERROR:
      return action.scheduleAddError;
    default:
      return state;
  }
};

const scheduleAddLoading = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_ADD_LOADING:
      return action.scheduleAddLoading;
    default:
      return state;
  }
};

const scheduleAddSuccess = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_ADD_SUCCESS:
      return action.scheduleAddSuccess;
    default:
      return state;
  }
};

const scheduleDeleteError = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_DELETE_ERROR:
      return action.scheduleDeleteError;
    default:
      return state;
  }
};

const scheduleDeleteLoading = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_DELETE_LOADING:
      return action.scheduleDeleteLoading;
    default:
      return state;
  }
};

const scheduleDeleteSuccess = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_DELETE_SUCCESS:
      return action.scheduleDeleteSuccess;
    default:
      return state;
  }
};

const handleChangeToPlanLoading = (state = false, action) => {
  switch (action.type) {
    case HANDLE_CHANGE_TO_PLAN_LOADING:
      return action.handleChangeToPlanLoading;
    default:
      return state;
  }
};

const handleChangeToPlanSuccess = (state = false, action) => {
  switch (action.type) {
    case HANDLE_CHANGE_TO_PLAN_SUCCESS:
      return action.handleChangeToPlanSuccess;
    default:
      return state;
  }
};

const handleChangeToPlanError = (state = false, action) => {
  switch (action.type) {
    case HANDLE_CHANGE_TO_PLAN_ERROR:
      return action.handleChangeToPlanError;
    default:
      return state;
  }
};

const handleShipArrivedLoading = (state = false, action) => {
  switch (action.type) {
    case HANDLE_SHIP_ARRIVED_LOADING:
      return action.handleShipArrivedLoading;
    default:
      return state;
  }
};

const handleShipArrivedSuccess = (state = false, action) => {
  switch (action.type) {
    case HANDLE_SHIP_ARRIVED_SUCCESS:
      return action.handleShipArrivedSuccess;
    default:
      return state;
  }
};

const handleShipArrivedError = (state = false, action) => {
  switch (action.type) {
    case HANDLE_SHIP_ARRIVED_ERROR:
      return action.handleShipArrivedError;
    default:
      return state;
  }
};

const getKsopPortLoading = (state = false, action) => {
  switch (action.type) {
    case GET_KSOP_PORT_LOADING:
      return action.getKsopPortLoading;
    default:
      return state;
  }
};

const getKsopPortSuccess = (state = false, action) => {
  switch (action.type) {
    case GET_KSOP_PORT_SUCCESS:
      return action.getKsopPortSuccess;
    default:
      return state;
  }
};

const getKsopPortData = (state = [], action) => {
  switch (action.type) {
    case GET_KSOP_PORT_SUCCESS:
      return action.data;
    default:
      return state;
  }
};

const getKsopPortError = (state = false, action) => {
  switch (action.type) {
    case GET_KSOP_PORT_ERROR:
      return action.getKsopPortError;
    default:
      return state;
  }
};

const getTrayekListLoading = (state = false, action) => {
  switch (action.type) {
    case GET_TRAYEK_LIST_LOADING:
      return action.getTrayekListLoading;
    default:
      return state;
  }
};

const getTrayekListSuccess = (state = false, action) => {
  switch (action.type) {
    case GET_TRAYEK_LIST_SUCCESS:
      return action.getTrayekListSuccess;
    default:
      return state;
  }
};

const getTrayekListData = (state = [], action) => {
  switch (action.type) {
    case GET_TRAYEK_LIST_SUCCESS:
      return action.data;
    default:
      return state;
  }
};

const getTrayekListError = (state = false, action) => {
  switch (action.type) {
    case GET_TRAYEK_LIST_ERROR:
      return action.getTrayekListError;
    default:
      return state;
  }
};

const getJadwalListLoading = (state = false, action) => {
  switch (action.type) {
    case GET_JADWAL_LIST_LOADING:
      return action.getJadwalListLoading;
    default:
      return state;
  }
};

const getJadwalListSuccess = (state = false, action) => {
  switch (action.type) {
    case GET_JADWAL_LIST_SUCCESS:
      return action.getJadwalListSuccess;
    default:
      return state;
  }
};

const getJadwalListData = (state = [], action) => {
  switch (action.type) {
    case GET_JADWAL_LIST_SUCCESS:
      return action.data;
    default:
      return state;
  }
};

const getJadwalListError = (state = false, action) => {
  switch (action.type) {
    case GET_JADWAL_LIST_ERROR:
      return action.getJadwalListError;
    default:
      return state;
  }
};

const getQuotaListLoading = (state = false, action) => {
  switch (action.type) {
    case GET_QUOTA_LIST_LOADING:
      return action.getQuotaListLoading;
    default:
      return state;
  }
};

const getQuotaListSuccess = (state = false, action) => {
  switch (action.type) {
    case GET_QUOTA_LIST_SUCCESS:
      return action.getQuotaListSuccess;
    default:
      return state;
  }
};

const getQuotaListData = (state = [], action) => {
  switch (action.type) {
    case GET_QUOTA_LIST_SUCCESS:
      return action.data;
    default:
      return state;
  }
};

const getQuotaListError = (state = false, action) => {
  switch (action.type) {
    case GET_QUOTA_LIST_ERROR:
      return action.getQuotaListError;
    default:
      return state;
  }
};

const updateQuotaLoading = (state = false, action) => {
  switch (action.type) {
    case UPDATE_QUOTA_LOADING:
      return action.updateQuotaLoading;
    default:
      return state;
  }
};

const updateQuotaSuccess = (state = false, action) => {
  switch (action.type) {
    case UPDATE_QUOTA_SUCCESS:
      return action.updateQuotaSuccess;
    default:
      return state;
  }
};

const updateQuotaData = (state = [], action) => {
  switch (action.type) {
    case UPDATE_QUOTA_SUCCESS:
      return action.data;
    default:
      return state;
  }
};

const updateQuotaError = (state = false, action) => {
  switch (action.type) {
    case UPDATE_QUOTA_ERROR:
      return action.updateQuotaError;
    default:
      return state;
  }
};

const scheduleReducer = combineReducers({
  scheduleGetBooking,
  scheduleApproveCancelContainer,
  scheduleGetContainerFromBooking,
  scheduleApproveCancelBooking,
  invalid,
  scheduleGetInvalid,
  scheduleGetHistory,
  history,
  scheduleGetVoyage,
  scheduleSuccessVoyage,
  scheduleUbahCommitted,

  scheduleGetError,
  scheduleGetLoading,
  scheduleGetSuccess,
  schedules,

  scheduleViewLoading,
  scheduleViewError,
  scheduleViewSuccess,
  schedule,

  scheduleAddError,
  scheduleAddLoading,
  scheduleAddSuccess,

  scheduleDeleteError,
  scheduleDeleteLoading,
  scheduleDeleteSuccess,

  handleChangeToPlanLoading,
  handleChangeToPlanSuccess,
  handleChangeToPlanError,

  handleShipArrivedLoading,
  handleShipArrivedSuccess,
  handleShipArrivedError,

  getKsopPortLoading,
  getKsopPortSuccess,
  getKsopPortData,
  getKsopPortError,

  getTrayekListLoading,
  getTrayekListSuccess,
  getTrayekListData,
  getTrayekListError,

  getJadwalListLoading,
  getJadwalListSuccess,
  getJadwalListData,
  getJadwalListError,

  getQuotaListLoading,
  getQuotaListSuccess,
  getQuotaListData,
  getQuotaListError,

  updateQuotaLoading,
  updateQuotaSuccess,
  updateQuotaData,
  updateQuotaError,
});

export default scheduleReducer;
